export const CPL_FORM_URL = '/application-form/?label=specialists_page';
export const PIK_LANDING_URL = 'https://www.cian.ru/pik-arenda/';
